import { useEditAbacAppMutation } from "../../../../AbacAppQueries";
import { object, string } from "yup";
import { useFormik } from "formik";
import { IApp, IEditApp } from "../../../../../../App/Typings/AbacApp";
import { useState, useCallback } from "react";
import { useNotification } from "../../../../../../App/State/Hooks/useNotificationHooks";

export default function useAbacAppDetailsState(currentApp: IApp) {
  const successMessage = "Successfully updated application information!";
  const errorMessage = "Error updating application information!";
  const { displaySuccess, displayError } = useNotification();
  const [isActive, setIsActive] = useState(currentApp.isActive);
  const { mutate: editApp, isLoading: editIsLoading } = useEditAbacAppMutation(
    currentApp.id
  );

  //Validation for the edit app form
  const validationSchema = object().shape({
    appName: string()
      .trim()
      .max(100, "App Name must be less than 100 characters")
      .required("App Name is required"),
    techStack: string()
      .trim()
      .max(50, "Tech Stack must be less than 50 characters"),
    appDescription: string().max(
      500,
      "App Description must be less than 500 characters"
    ),
  });

  //Initial edit app formik setup
  const formik = useFormik({
    initialValues: {
      appName: currentApp.name,
      techStack: currentApp.techStack,
      appDescription: currentApp.description,
    },
    validationSchema: validationSchema,
    // Create the IEditApp object to pass to the mutation
    onSubmit: (values) => {
      // Remove whitespace from formik values
      formik.setValues({
        appName: values.appName.trim(),
        techStack: values.techStack.trim(),
        appDescription: values.appDescription.trim(),
      });
      let editedApp: IEditApp = {
        id: currentApp.id,
        appName: values.appName.trim(),
        techStack: values.techStack.trim(),
        appDescription: values.appDescription.trim(),
        isActive: isActive,
      };
      editApplication(editedApp);
    },
  });

  // Edit the current ABAC application
  const editApplication = useCallback(
    function saveAppInformation(editedApp: IEditApp) {
      if (!editIsLoading) {
        editApp(editedApp, {
          onError: () => {
            displayError(errorMessage);
          },
          onSuccess: () => {
            displaySuccess(successMessage);
          },
        });
      }
    },
    [displaySuccess, displayError, editApp, editIsLoading]
  );

  return {
    getters: {
      isActive,
      formik,
    },
    setters: {
      setIsActive,
    },
    handlers: {},
  };
}
